import { Globe } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { getLanguageMeta, getRegionLanguages } from "../i18n/languages";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher({ className = "" }) {
  const { language, setLanguage } = useLanguage();
  const options = getRegionLanguages();

  if (options.length <= 1) {
    return null;
  }

  const current = getLanguageMeta(language);

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start gap-2 text-muted-foreground hover:text-foreground"
          >
            <Globe className="w-4 h-4" />
            {current.nativeLabel}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {options.map((code) => {
            const meta = getLanguageMeta(code);
            return (
              <DropdownMenuItem key={code} onClick={() => setLanguage(code)}>
                {meta.nativeLabel}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
